var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShezhi2Mian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.647 9.013a5.4 5.4 0 010-1.98l-1.374-.786a.542.542 0 01-.2-.743l1.278-2.192a.542.542 0 01.737-.197l1.381.791A5.505 5.505 0 016.2 2.913V1.342c0-.3.243-.542.542-.542h2.56c.3 0 .543.243.543.542v1.57c.64.227 1.224.564 1.73.994l1.382-.79a.542.542 0 01.737.196l1.277 2.192a.542.542 0 01-.199.743l-1.374.787a5.401 5.401 0 010 1.979l1.374.787c.261.15.35.483.199.743l-1.277 2.191a.542.542 0 01-.737.198l-1.381-.791c-.51.434-1.098.77-1.731.993v1.571c0 .3-.243.542-.542.542H6.742a.542.542 0 01-.542-.542v-1.571a5.472 5.472 0 01-1.731-.993l-1.381.79a.542.542 0 01-.737-.197l-1.277-2.191a.542.542 0 01.199-.743l1.374-.787zM8 11a3 3 0 100-6 3 3 0 000 6z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shezhi2_mian.e0815127.svg";
export { SvgTongyongShezhi2Mian as ReactComponent };